import company from './company';

export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {},
    modules: {
        company,
    },
};
